import LocalizationService from '../../../Services/Services.Secondary/Localization/LocalizationService';

var resx = LocalizationService.getInstance();

export default class CountryInformationService {
  private static instance: CountryInformationService;
  private supportCountryCodes: string[] = [
    'AF',
    'AL',
    'DZ',
    'AD',
    'AR',
    'AO',
    'AI',
    'AG',
    'AQ',
    'AS',
    'AM',
    'AU',
    'AW',
    'AT',
    'AZ',
    'BH',
    'BS',
    'BB',
    'BD',
    'BY',
    'BE',
    'BR',
    'BJ',
    'BM',
    'BT',
    'BO',
    'BA',
    'BW',
    'BZ',
    'BG',
    'BV',
    'IO',
    'BN',
    'VG',
    'BF',
    'BI',
    'CA',
    'CM',
    'KH',
    'CL',
    'CV',
    'CF',
    'KY',
    'TD',
    'CN',
    'CO',
    'CC',
    'CR',
    'CG',
    'CD',
    'CK',
    'KM',
    'CI',
    'HR',
    'CU',
    'CY',
    'CZ',
    'DK',
    'DJ',
    'DM',
    'DO',
    'EC',
    'EG',
    'SV',
    'EE',
    'ER',
    'GQ',
    'ET',
    'FI',
    'FK',
    'FJ',
    'FO',
    'FR',
    'DE',
    'GF',
    'GA',
    'PF',
    'GM',
    'TF',
    'GE',
    'GH',
    'GI',
    'GR',
    'GL',
    'GD',
    'GP',
    'GT',
    'GU',
    'GN',
    'GW',
    'GY',
    'HK',
    'HM',
    'HT',
    'HN',
    'VA',
    'HU',
    'IS',
    'IN',
    'ID',
    'IQ',
    'IE',
    'IR',
    'IL',
    'IT',
    'JM',
    'JP',
    'JO',
    'KZ',
    'KE',
    'KI',
    'KR',
    'KW',
    'KG',
    'LA',
    'LV',
    'LB',
    'LI',
    'LR',
    'LS',
    'LY',
    'LT',
    'LU',
    'MK',
    'MO',
    'MG',
    'MW',
    'MY',
    'MT',
    'ML',
    'MV',
    'MH',
    'MQ',
    'MR',
    'MU',
    'MX',
    'YT',
    'FM',
    'MD',
    'MC',
    'ME',
    'MN',
    'MA',
    'MS',
    'MZ',
    'MM',
    'NA',
    'NL',
    'NP',
    'NR',
    'NC',
    'NZ',
    'NG',
    'NE',
    'NI',
    'NF',
    'NO',
    'KP',
    'MP',
    'NU',
    'OM',
    'PK',
    'PA',
    'PS',
    'PW',
    'PG',
    'PY',
    'PE',
    'PH',
    'PL',
    'PN',
    'PT',
    'PR',
    'QA',
    'RE',
    'RO',
    'RU',
    'RW',
    'BL',
    'LC',
    'KN',
    'SA',
    'PM',
    'SH',
    'VC',
    'SM',
    'WS',
    'RS',
    'SN',
    'ST',
    'SC',
    'SG',
    'SL',
    'SK',
    'SI',
    'SB',
    'SO',
    'ZA',
    'ES',
    'GS',
    'LK',
    'SS',
    'SD',
    'SE',
    'SJ',
    'SR',
    'SZ',
    'CH',
    'SY',
    'TW',
    'TH',
    'TJ',
    'TZ',
    'TG',
    'TL',
    'TK',
    'TO',
    'TT',
    'TN',
    'TR',
    'TM',
    'TC',
    'TV',
    'UA',
    'UG',
    'AE',
    'GB',
    'US',
    'UY',
    'UM',
    'VE',
    'UZ',
    'VI',
    'VU',
    'VN',
    'WF',
    'YE',
    'ZM',
    'ZW',
  ];

  private constructor() {}
  public static getInstance = () => {
    if (!CountryInformationService.instance) {
      CountryInformationService.instance = new CountryInformationService();
    }
    return CountryInformationService.instance;
  };
  public getCountryLocalizedList = (): { [key: string]: string } => {
    /// <summary>
    /// Gets the list of countries
    /// </summary>
    return {
      Austria: resx.getLocalizedResource('CountryInformation_text_AT'),
      Switzerland: resx.getLocalizedResource('CountryInformation_text_CH'),
      Germany: resx.getLocalizedResource('CountryInformation_text_DE'),
      Greece: resx.getLocalizedResource('CountryInformation_text_GR'),
      Australia: resx.getLocalizedResource('CountryInformation_text_AU'),
      Bangladesh: resx.getLocalizedResource('CountryInformation_text_BD'),
      Belgium: resx.getLocalizedResource('CountryInformation_text_BE'),
      Bahrain: resx.getLocalizedResource('CountryInformation_text_BH'),
      Canada: resx.getLocalizedResource('CountryInformation_text_CA'),
      Cyprus: resx.getLocalizedResource('CountryInformation_text_CY'),
      Denmark: resx.getLocalizedResource('CountryInformation_text_DK'),
      Estonia: resx.getLocalizedResource('CountryInformation_text_EE'),
      Egypt: resx.getLocalizedResource('CountryInformation_text_EG'),
      Finland: resx.getLocalizedResource('CountryInformation_text_FI'),
      Croatia: resx.getLocalizedResource('CountryInformation_text_HR'),
      Indonesia: resx.getLocalizedResource('CountryInformation_text_ID'),
      Ireland: resx.getLocalizedResource('CountryInformation_text_IE'),
      Israel: resx.getLocalizedResource('CountryInformation_text_IL'),
      India: resx.getLocalizedResource('CountryInformation_text_IN'),
      Jamaica: resx.getLocalizedResource('CountryInformation_text_JM'),
      Jordan: resx.getLocalizedResource('CountryInformation_text_JO'),
      Kenya: resx.getLocalizedResource('CountryInformation_text_KE'),
      Kuwait: resx.getLocalizedResource('CountryInformation_text_KW'),
      Lebanon: resx.getLocalizedResource('CountryInformation_text_LB'),
      Latvia: resx.getLocalizedResource('CountryInformation_text_LV'),
      Malta: resx.getLocalizedResource('CountryInformation_text_MT'),
      Malaysia: resx.getLocalizedResource('CountryInformation_text_MY'),
      Namibia: resx.getLocalizedResource('CountryInformation_text_NA'),
      Nigeria: resx.getLocalizedResource('CountryInformation_text_NG'),
      Netherlands: resx.getLocalizedResource('CountryInformation_text_NL'),
      Norway: resx.getLocalizedResource('CountryInformation_text_NO'),
      Oman: resx.getLocalizedResource('CountryInformation_text_OM'),
      Philippines: resx.getLocalizedResource('CountryInformation_text_PH'),
      Pakistan: resx.getLocalizedResource('CountryInformation_text_PK'),
      Qatar: resx.getLocalizedResource('CountryInformation_text_QA'),
      Serbia: resx.getLocalizedResource('CountryInformation_text_RS'),
      Sweden: resx.getLocalizedResource('CountryInformation_text_SE'),
      Singapore: resx.getLocalizedResource('CountryInformation_text_SG'),
      Vietnam: resx.getLocalizedResource('CountryInformation_text_VN'),
      Argentina: resx.getLocalizedResource('CountryInformation_text_AR'),
      Bolivia: resx.getLocalizedResource('CountryInformation_text_BO'),
      Chile: resx.getLocalizedResource('CountryInformation_text_CL'),
      Ecuador: resx.getLocalizedResource('CountryInformation_text_EC'),
      Spain: resx.getLocalizedResource('CountryInformation_text_ES'),
      Guatemala: resx.getLocalizedResource('CountryInformation_text_GT'),
      Honduras: resx.getLocalizedResource('CountryInformation_text_HN'),
      Mexico: resx.getLocalizedResource('CountryInformation_text_MX'),
      Nicaragua: resx.getLocalizedResource('CountryInformation_text_NI'),
      Panama: resx.getLocalizedResource('CountryInformation_text_PA'),
      Peru: resx.getLocalizedResource('CountryInformation_text_PE'),
      Paraguay: resx.getLocalizedResource('CountryInformation_text_PY'),
      Uruguay: resx.getLocalizedResource('CountryInformation_text_UY'),
      Venezuela: resx.getLocalizedResource('CountryInformation_text_VE'),
      Algeria: resx.getLocalizedResource('CountryInformation_text_DZ'),
      France: resx.getLocalizedResource('CountryInformation_text_FR'),
      Morocco: resx.getLocalizedResource('CountryInformation_text_MA'),
      Mauritius: resx.getLocalizedResource('CountryInformation_text_MU'),
      Tunisia: resx.getLocalizedResource('CountryInformation_text_TN'),
      Hungary: resx.getLocalizedResource('CountryInformation_text_HU'),
      Italy: resx.getLocalizedResource('CountryInformation_text_IT'),
      Japan: resx.getLocalizedResource('CountryInformation_text_JP'),
      Korea: resx.getLocalizedResource('CountryInformation_text_KR'),
      Poland: resx.getLocalizedResource('CountryInformation_text_PL'),
      Angola: resx.getLocalizedResource('CountryInformation_text_AO'),
      Brazil: resx.getLocalizedResource('CountryInformation_text_BR'),
      Portugal: resx.getLocalizedResource('CountryInformation_text_PT'),
      Romania: resx.getLocalizedResource('CountryInformation_text_RO'),
      Kazakhstan: resx.getLocalizedResource('CountryInformation_text_KZ'),
      Russia: resx.getLocalizedResource('CountryInformation_text_RU'),
      Ukraine: resx.getLocalizedResource('CountryInformation_text_UA'),
      Slovakia: resx.getLocalizedResource('CountryInformation_text_SK'),
      Slovenia: resx.getLocalizedResource('CountryInformation_text_SI'),
      Thailand: resx.getLocalizedResource('CountryInformation_text_TH'),
      Turkey: resx.getLocalizedResource('CountryInformation_text_TR'),
      Taiwan: resx.getLocalizedResource('CountryInformation_text_TW'),
      CzechRepublic: resx.getLocalizedResource('CountryInformation_text_CZ'),
      UnitedArabEmirates: resx.getLocalizedResource('CountryInformation_text_AE'),
      UnitedKingdom: resx.getLocalizedResource('CountryInformation_text_GB'),
      HongKong: resx.getLocalizedResource('CountryInformation_text_HK'),
      SriLanka: resx.getLocalizedResource('CountryInformation_text_LK'),
      NewZealand: resx.getLocalizedResource('CountryInformation_text_NZ'),
      PuertoRico: resx.getLocalizedResource('CountryInformation_text_PR'),
      SaudiArabia: resx.getLocalizedResource('CountryInformation_text_SA'),
      UnitedStates: resx.getLocalizedResource('CountryInformation_text_US'),
      SouthAfrica: resx.getLocalizedResource('CountryInformation_text_ZA'),
      Columbia: resx.getLocalizedResource('CountryInformation_text_CO'),
      CostaRica: resx.getLocalizedResource('CountryInformation_text_CR'),
      DominicanRepublic: resx.getLocalizedResource('CountryInformation_text_DO'),
      ElSalvador: resx.getLocalizedResource('CountryInformation_text_SV'),
      IvoryCoast: resx.getLocalizedResource('IvoryCoast_text'),
      Luxenburg: resx.getLocalizedResource('CountryInformation_text_LU'),
      China: resx.getLocalizedResource('CountryInformation_text_CN'),
    };
  };

  public getSupportCountryCodes(): string[] {
    return this.supportCountryCodes;
  }

  public getSupportCountryLocalizedName(code: string): string {
    return resx.getLocalizedResource('CountryInformation_text_' + code);
  }

  public getSupportedLanguagesList = () => {
    /// <summary>
    /// Gets the list of supported languages.
    /// </summary>
    return {
      'zh-tw': '中文(繁體)',
      'zh-cn': '中文(简体)',
      'de-de': 'Deutsch',
      'en-us': 'English',
      'es-es': 'Español',
      'fr-fr': 'Français',
      'it-it': 'Italiano',
      'ja-jp': '日本語',
      'ko-kr': '한국어',
      'pt-br': 'Português',
      'ru-ru': 'Русский',
    };
  };
  public getLocaleToCountryDictionary = () => {
    return {
      'en-us': 'UnitedStates',
      'ar-sa': 'SaudiArabia',
      'eu-es': 'Spain',
      'bg-bg': 'UnitedStates',
      'ca-es': 'Spain',
      'zh-cn': 'China',
      'zh-tw': 'Taiwan',
      'hr-hr': 'Croatia',
      'cs-cz': 'CzechRepublic',
      'da-dk': 'Denmark',
      'nl-nl': 'Netherlands',
      'et-ee': 'Estonia',
      'fi-fi': 'Finland',
      'fr-fr': 'France',
      'gl-es': 'Spain',
      'de-de': 'Germany',
      'el-gr': 'Greece',
      'he-il': 'Greece',
      'hi-in': 'India',
      'hu-hu': 'Hungary',
      'id-id': 'Indonesia',
      'it-it': 'Italy',
      'ja-jp': 'Japan',
      'kk-kz': 'Kazakhstan',
      'ko-kr': 'Korea',
      'lv-lv': 'Latvia',
      'lt-lt': 'UnitedStates',
      'ms-my': 'Malaysia',
      'nb-no': 'Norway',
      'pl-pl': 'Poland',
      'pt-br': 'Brazil',
      'pt-pt': 'Portugal',
      'ro-ro': 'Romania',
      'ru-ru': 'Russia',
      'sr-latn-rs': 'UnitedStates',
      'sk-sk': 'Slovakia',
      'sl-si': 'Slovenia',
      'es-es': 'Spain',
      'sv-se': 'Sweden',
      'th-th': 'Thailand',
      'tr-tr': 'Turkey',
      'uk-ua': 'Ukraine',
      'vi-vn': 'Vietnam',
    };
  };

  public getCountryToPhoneNumberDictionary = () => {
    return {
      Algeria: ['+213 21891070'],
      Angola: ['+351 214154065'],
      Argentina: ['0-800-222-9467', '11-5776-1000 (local)'],
      Australia: ['13 20 58 Options 3, 1', '+612 9870 2200 Options 3,1'],
      Austria: ['0-8000-123-345'],
      Bahrain: ['80004500'],
      Bangladesh: [
        'Bangladesh and Nepal 1800 102 1100 (Local Toll-Free)',
        'Bangladesh and Nepal 1800 11 11 00 (Local Toll-Free)',
        'Bangladesh and Nepal +91 80 4010 3000  (Local Toll-Free)',
      ],
      Belgium: ['+32-2-704-3260 (en anglais)', '+32-2-704-3259'],
      Bolivia: ['800-100-714'],
      Brazil: ['0-800-761-7454', '11-4706-0900'],
      Canada: ['1-800-MPN-SOLVE (1-800-676-7658)', '1-877-453-1317 (French)', '1-877-453-1317 (en anglais)'],
      Chile: ['800-202-011'],
      China: ['800-819-0550 (toll free)', '400-620-0550 (Mobile)'],
      Columbia: ['1-800-093-1234', '1-587-0300 (local)'],
      CostaRica: ['0-800-016-1034'],
      Croatia: ['0800 300 300', '+385 (0)1 7890 300', '0800 222 225  Billing'],
      Cyprus: ['+357 22674000'],
      CzechRepublic: ['841300300'],
      Denmark: ['+45-82-33-3290'],
      DominicanRepublic: ['1-800-751-3455', '1-809-200-8794 (cellular only)'],
      Ecuador: ['1-800-010-288'],
      Egypt: ['+20 2 3539 3333'],
      ElSalvador: ['800-6676'],
      Estonia: ['+372 6868868'],
      Finland: ['+358-9-817-10444'],
      France: ['+33-9-70-01-90-90'],
      Germany: ['+49-180-6-302525'],
      Greece: ['+30-2111-206500'],
      Guatemala: ['1-800-300-0069'],
      Honduras: ['800-2791-9298'],
      HongKong: ['+852-23889600', '+852-2388960, select your language, then option 5, then option 3'],
      Hungary: ['+36-1-267-4636'],
      India: [
        '1-800-102-1100 (toll free from Airtel land line and mobile phones)',
        '1-800-111-100 (toll free from MTNL/BSNL land line)',
        '+91-80-40103000 (toll number)',
      ],
      Indonesia: ['001-803-440-421 (toll free)', '+62-21-25-528-700 (charge)'],
      Ireland: ['+353-1-7065353'],
      Israel: ['+972 97625400'],
      Italy: ['+39-02-3859-1433'],
      IvoryCoast: ['+225 20242490'],
      Jamaica: ['866-993-9302'],
      Japan: ['+81-120-17-0196'],
      Jordan: ['0 800 22730'],
      Kazakhstan: ['7-3272-980126'],
      Kenya: ['+254 202868800'],
      Korea: ['080-542-1000'],
      Kuwait: ['+965 22219876'],
      Latvia: ['+371 67852152'],
      Lebanon: ['+961 1974081'],
      Luxenburg: ['+33-9-70-01-90-90'],
      Malaysia: ['1-800-885-648'],
      Malta: ['80062037'],
      Mauritius: ['+230 2028120'],
      Mexico: ['01-800-123-3353'],
      Morocco: ['+212 522956150'],
      Namibia: ['+264 612925016'],
      Netherlands: ['+31-20-500-1500'],
      NewZealand: ['0800-800-004, option 4'],
      Nicaragua: ['00-1-800-220-1803'],
      Nigeria: ['+234 12710156'],
      Norway: ['47-235-400'],
      Oman: ['80073332', '+968 2444 6487'],
      Pakistan: ['+92 21 111 674357'],
      Panama: ['00-800-051-0398'],
      Paraguay: ['009-800-54-2-0049'],
      Peru: ['0-800-54-238 0', '1-390-1201 (cellular only)'],
      Philippines: ['1-800-1441-4127'],
      Poland: ['0801-67-4636 (mobile phone)', '22-594-1997 (landline)'],
      Portugal: ['0808-22-32-42'],
      PuertoRico: ['1-877-678-8032'],
      Qatar: ['+974 44119420', '+974 44119418'],
      Romania: ['0801 022 222   Română', '+40 212047040'],
      Russia: ['8-800-200-8002'],
      SaudiArabia: ['+966 112988100'],
      Serbia: ['0700 300 300', '+381 (0)11 330 55 00', '0800 190 095  Billing'],
      Singapore: ['1800 8209966'],
      Slovakia: ['0850-111-300, select option 3, then select option 2 or 3'],
      Slovenia: ['+386 15853449'],
      SouthAfrica: ['0-860-677278'],
      Spain: ['+34-91-754-70-10'],
      SriLanka: [
        '1-800-102-1100 (toll free from Airtel land line and mobile phones)',
        '1-800-111-100 (toll free from MTNL/BSNL land line)',
        '+91-80-40103000 (toll number)',
      ],
      Sweden: ['+46 855990003'],
      Switzerland: ['+41-848-687-773'],
      Taiwan: ['080-0008833', '886-2-29998833'],
      Thailand: ['001800-441-0218'],
      Tunisia: ['+216 71168700'],
      Turkey: ['+90 850 390 2777'],
      Ukraine: ['+38-044-230-51-02'],
      UnitedArabEmirates: ['+966 112988100'],
      UnitedKingdom: ['+44 344 800 6006'],
      UnitedStates: ['1-800-MPN-SOLVE (1-800-676-7658)'],
      Uruguay: ['000-4054-083'],
      Venezuela: ['800-100-4610'],
      Vietnam: ['1800400470', '+60 3 9212 1942 (charge)'],
    };
  };
}
